import cn from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'
import { WarningIcon } from 'partner360/components/QBR/shared/warningIcon/WarningIcon'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import styles from './FinalizeAlert.module.scss'

export const FinalizeAlert = () => {
  return (
    <div className={cn(styles.root)}>
      <WarningIcon />
      <div className={styles.text}>
        <Translation text={TRANSLATION_KEYS.finalizeAlert} />
      </div>
    </div>
  )
}
